import React from 'react'

import UsersTable from 'components/UsersTable'
import userDomain from 'domains/user'

export function UsersList({
  accounts,
  userMe,
  roleOptions,
  surveyAccessSelectableRoles,
  dashbardAccessesSelectableRoles,
  teamMembers,
  isTeamMembersLoading,
}) {
  const antdDataSource = userDomain.transformAccountsToAntdDataSource(accounts)

  return (
    <React.Fragment>
      <UsersTable
        dataSource={antdDataSource}
        userMe={userMe}
        roleOptions={roleOptions}
        surveyAccessSelectableRoles={surveyAccessSelectableRoles}
        dashbardAccessesSelectableRoles={dashbardAccessesSelectableRoles}
        teamMembers={teamMembers}
        isTeamMembersLoading={isTeamMembersLoading}
      />
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/UsersList/index.js